import DOMPurify from "dompurify";

export default function sanitizeHTML(html: string, allowedAttributes: string[] = ["target"]): { __html: string } {
  return { __html: DOMPurify.sanitize(html, { ADD_ATTR: allowedAttributes }) };
}
